/**
 *
 * Asynchronously loads the component for Istituto
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./app/containers/Istituto/Loadable.js